/**
 * PHARMAKON — BETA seed composer
 *
 * Builds the full demo dataset for a given role. Each domain lives in its
 * own ./data/*.js module exporting a `build*` function that returns a
 * plain array (or object for singletons). This file simply composes them
 * and returns the unified store.
 */
import { buildPharmacie } from "./data/pharmacie.js";
import { buildUsers } from "./data/users.js";
import { buildLaboratoires } from "./data/laboratoires.js";
import { buildFournisseurs } from "./data/fournisseurs.js";
import { buildProduits } from "./data/produits.js";
import { buildStockLots } from "./data/stock-lots.js";
import { buildEmplacements } from "./data/emplacements.js";
import { buildClients } from "./data/clients.js";
import { buildAchats } from "./data/achats.js";
import { buildVentes } from "./data/ventes.js";
import { buildCaisses } from "./data/caisses.js";
import { buildAvoirs } from "./data/avoirs.js";
import { buildInstances } from "./data/instances.js";
import { buildEfactures } from "./data/efactures.js";
import { buildNotifications } from "./data/notifications.js";
import { buildAudit } from "./data/audit.js";
import { buildModules } from "./data/modules.js";

export function buildSeed(role) {
  const pharmacie = buildPharmacie();
  const users = buildUsers(role);
  const laboratoires = buildLaboratoires();
  const fournisseurs = buildFournisseurs();
  const produits = buildProduits();
  const stockLots = buildStockLots(produits);
  const emplacements = buildEmplacements(produits);
  const clients = buildClients();
  const achats = buildAchats(fournisseurs, produits, stockLots, users);
  const ventes = buildVentes(produits, stockLots, clients, users);
  const caisses = buildCaisses(users, ventes);
  const avoirs = buildAvoirs(achats, fournisseurs);
  const instances = buildInstances(clients, produits, stockLots, users);
  const efactures = buildEfactures(fournisseurs, produits);
  const notifications = buildNotifications(role);
  const audit = buildAudit(users);
  const modules = buildModules();

  return {
    pharmacie,
    users,
    laboratoires,
    fournisseurs,
    produits,
    stockLots,
    emplacements,
    clients,
    achats,
    ventes,
    caisses,
    avoirs,
    instances,
    efactures,
    notifications,
    audit,
    modules,
    // Mutable scratch space some handlers need (e.g. pending supplier reqs)
    pendingSuppliers: [],
    tickets: [],
    rotations: [],
    offresManuelles: [],
    settings: {
      aide_decision: { lookback_months: 6, top_n: 50 },
    },
  };
}
